import React, { useState } from 'react';
import { ArrowLeft, Wand2, ChevronDown } from 'lucide-react';
import { Zone } from '../hooks/useInventory';
interface AddItemProps {
  onAdd: (item: any) => void;
  onCancel: () => void;
}
const CATEGORIES = ['Dairy', 'Produce', 'Meat', 'Bakery', 'Dry Goods', 'Cooking', 'Beverages', 'Snacks', 'Toiletries', 'Cleaning', 'Paper Goods', 'Other'];
const UNITS = ['pieces', 'lbs', 'oz', 'gallon', 'bottles', 'boxes', 'bags', 'cans', 'rolls', 'tubes', 'cups', 'packs'];
export function AddItem({
  onAdd,
  onCancel
}: AddItemProps) {
  const [formData, setFormData] = useState({
    name: '',
    category: 'Dry Goods',
    quantity: '',
    unit: 'pieces',
    maxQuantity: '',
    zone: 'Kitchen Pantry' as Zone,
    expiryDate: '',
    notes: ''
  });
  return <div className="p-4 pb-24 max-w-md mx-auto min-h-screen" data-id="element-97">
      <div className="flex items-center mb-6" data-id="element-98">
        <button onClick={onCancel} className="mr-3 p-2 hover:bg-[#C9A227]/20 rounded-full transition-colors" data-id="element-99">
          <ArrowLeft className="w-5 h-5 text-[#722F37]" data-id="element-100" />
        </button>
        <h1 className="text-xl font-cinzel font-bold text-[#2C2C2C]" data-id="element-101">
          Conjure New Item
        </h1>
      </div>

      {/* Scan Button */}
      <button className="w-full mb-8 p-4 bg-[#2C2C2C] text-[#F5F0E1] rounded-xl flex items-center justify-center gap-3 active:bg-black transition-colors border border-[#C9A227] shadow-md group" data-id="element-102">
        <Wand2 className="w-5 h-5 text-[#C9A227] group-hover:animate-pulse" data-id="element-103" />
        <span className="font-cinzel font-bold tracking-wide" data-id="element-104">
          Divination Scan
        </span>
      </button>

      <form className="space-y-5" onSubmit={e => {
      e.preventDefault();
      onAdd({
        ...formData,
        quantity: parseInt(formData.quantity) || 1,
        maxQuantity: parseInt(formData.maxQuantity) || parseInt(formData.quantity) * 2 || 2
      });
    }} data-id="element-105">
        <div className="bg-[#FFFDF5] p-6 rounded-xl border border-[#C9A227]/40 shadow-sm relative" data-id="element-106">
          {/* Parchment corner effect */}
          <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-bl from-[#C9A227]/10 to-transparent rounded-tr-xl" data-id="element-107" />

          <div className="space-y-5" data-id="element-108">
            <div data-id="element-109">
              <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-110">
                Item Name
              </label>
              <input type="text" value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg text-[#2C2C2C] font-serif focus:border-[#722F37] focus:bg-[#FFFDF5] outline-none transition-colors placeholder-[#2C2C2C]/30" placeholder="e.g., Dragon Egg, Mandrake Root..." required data-id="element-111" />
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-112">
              <div data-id="element-113">
                <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-114">
                  Category
                </label>
                <div className="relative" data-id="element-115">
                  <select value={formData.category} onChange={e => setFormData({
                  ...formData,
                  category: e.target.value
                })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg appearance-none focus:border-[#722F37] outline-none font-serif text-[#2C2C2C]" data-id="element-116">
                    {CATEGORIES.map(cat => <option key={cat} value={cat} data-id="element-117">
                        {cat}
                      </option>)}
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#722F37] pointer-events-none" data-id="element-118" />
                </div>
              </div>

              <div data-id="element-119">
                <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-120">
                  Location
                </label>
                <div className="relative" data-id="element-121">
                  <select value={formData.zone} onChange={e => setFormData({
                  ...formData,
                  zone: e.target.value as Zone
                })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg appearance-none focus:border-[#722F37] outline-none font-serif text-[#2C2C2C]" data-id="element-122">
                    <option value="Kitchen Pantry" data-id="element-123">Provisions</option>
                    <option value="Refrigerator" data-id="element-124">Cold Storage</option>
                    <option value="Freezer" data-id="element-125">Deep Freeze</option>
                    <option value="Bathroom" data-id="element-126">Apothecary</option>
                    <option value="Cleaning Closet" data-id="element-127">Maintenance</option>
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#722F37] pointer-events-none" data-id="element-128" />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3" data-id="element-129">
              <div data-id="element-130">
                <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-131">
                  Qty
                </label>
                <input type="number" value={formData.quantity} onChange={e => setFormData({
                ...formData,
                quantity: e.target.value
              })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg focus:border-[#722F37] outline-none font-serif text-[#2C2C2C]" placeholder="1" required data-id="element-132" />
              </div>
              <div data-id="element-133">
                <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-134">
                  Unit
                </label>
                <div className="relative" data-id="element-135">
                  <select value={formData.unit} onChange={e => setFormData({
                  ...formData,
                  unit: e.target.value
                })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg appearance-none focus:border-[#722F37] outline-none font-serif text-[#2C2C2C]" data-id="element-136">
                    {UNITS.map(unit => <option key={unit} value={unit} data-id="element-137">
                        {unit}
                      </option>)}
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#722F37] pointer-events-none" data-id="element-138" />
                </div>
              </div>
              <div data-id="element-139">
                <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-140">
                  Max
                </label>
                <input type="number" value={formData.maxQuantity} onChange={e => setFormData({
                ...formData,
                maxQuantity: e.target.value
              })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg focus:border-[#722F37] outline-none font-serif text-[#2C2C2C]" placeholder="Auto" data-id="element-141" />
              </div>
            </div>

            <div data-id="element-142">
              <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-143">
                Expiry Date
              </label>
              <input type="date" value={formData.expiryDate} onChange={e => setFormData({
              ...formData,
              expiryDate: e.target.value
            })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg focus:border-[#722F37] outline-none font-serif text-[#2C2C2C]" data-id="element-144" />
            </div>

            <div data-id="element-145">
              <label className="block text-xs font-bold uppercase tracking-widest text-[#722F37] mb-2" data-id="element-146">
                Notes
              </label>
              <textarea value={formData.notes} onChange={e => setFormData({
              ...formData,
              notes: e.target.value
            })} className="w-full p-3 bg-[#F5F0E1] border-b-2 border-[#C9A227]/30 rounded-t-lg focus:border-[#722F37] outline-none resize-none font-serif text-[#2C2C2C]" placeholder="Enchantments, specific brands..." rows={2} data-id="element-147" />
            </div>
          </div>
        </div>

        <div className="pt-2 flex gap-3" data-id="element-148">
          <button type="button" onClick={onCancel} className="flex-1 p-4 text-[#722F37] font-cinzel font-bold border-2 border-[#722F37]/30 rounded-xl hover:bg-[#722F37]/5 transition-colors" data-id="element-149">
            Vanish
          </button>
          <button type="submit" className="flex-1 p-4 bg-[#722F37] text-[#F5F0E1] rounded-xl font-cinzel font-bold shadow-lg shadow-[#722F37]/30 active:scale-[0.98] transition-transform border-2 border-[#C9A227] hover:bg-[#8B3A44]" data-id="element-150">
            Conjure Item
          </button>
        </div>
      </form>
    </div>;
}